export const CREATE_PALLET_RECEIVE = 'CREATE_PALLET_RECEIVE';
export const GET_PALLET_RECEIVE = 'GET_PALLET_RECEIVE';
export const PALLET_RECEIVE_REQUEST = 'PALLET_RECEIVE_REQUEST';
export const PALLET_RECEIVE_REQUEST_SUCCESS = 'PALLET_RECEIVE_REQUEST_SUCCESS';
export const UPDATE_PALLET_RECEIVE = 'UPDATE_PALLET_RECEIVE';
export const DELETE_PALLET_RECEIVE = 'DELETE_PALLET_RECEIVE';
export const PALLET_RECEIVE_REQUEST_FAILURE = 'PALLET_RECEIVE_REQUEST_FAILURE';
export const GET_PALLET_RECEIVES_PAGE = 'GET_PALLET_RECEIVES_PAGE';

